// Preference helpers for the peripheral colour pulse that syncs to the
// breath phase. Default ON — the effect is quiet enough (peak ~12% at
// soft-light blend) that it rarely warrants being off, but photosensitive
// users can still switch it off from inside the breathing exercise.
// by David Hunt

const KEY = "stillwater.breathColorPulse";

export const loadBreathPulsePreference = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw === null ? true : raw === "true";
  } catch (_) {
    return true;
  }
};

export const saveBreathPulsePreference = (value) => {
  try {
    localStorage.setItem(KEY, String(!!value));
  } catch (_) {
    /* silent */
  }
};
